module.exports = __webpack_public_path__ + "static/media/3.bad6416b.png";